import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography';

import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';
import { Sidebar } from '@futrli/ui-components';
import { ProcessedUserRow } from '@futrli/views/processors/users/usersList';

import { ModifyUserContainer } from './containers/modify-user-container';
import { ModifyUserContextProvider } from './context/modify-user-context';

interface ModifyUserSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  user: ProcessedUserRow;
  workspaceId: string;
}

export const ModifyUserSidebar = ({ isOpen, onClose, user, workspaceId }: ModifyUserSidebarProps) => {
  const intl = useIntl();
  const { resetKey } = useSidebarResetCounter(isOpen);

  return (
    <Sidebar
      aria-label={intl.formatMessage({
        id: 'predict.workspaces.users.modify.aria_label',
        defaultMessage: 'User settings sidebar'
      })}
      header={
        <Typography fontWeight="700" variant="h2">
          <FormattedMessage id="predict.workspaces.users.settings" defaultMessage="User settings" />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
      size="medium-large"
    >
      <ModifyUserContextProvider key={resetKey} user={user} workspaceId={workspaceId}>
        <ModifyUserContainer onClose={onClose} />
      </ModifyUserContextProvider>
    </Sidebar>
  );
};
